<div class="flex h-full w-full flex-col">
  <form
    class="flex w-full flex-1 flex-col gap-4"
    (ngSubmit)="onSubmit()"
    [formGroup]="form">
    <!-- Name Field -->
    <div class="flex w-full flex-col gap-2">
      <p class="text-sm font-semibold text-zinc-700 dark:text-zinc-300">
        {{ 'common.name' | translate }}
      </p>
      <input
        formControlName="name"
        class="border-default bg-elevated focus:ring-accent-focus w-full rounded-lg border px-3 py-2.5 text-sm transition-all focus:border-transparent focus:ring-2 focus:outline-none disabled:opacity-60"
        [class.border-red-500]="form.get('name')?.invalid && form.get('name')?.touched"
        [class.focus:ring-red-500]="form.get('name')?.invalid && form.get('name')?.touched"
        type="text" />

      @if (form.get('name')?.invalid && form.get('name')?.touched) {
        <div class="flex flex-col gap-1 text-xs text-red-500">
          @if (form.get('name')?.errors?.['required']) {
            <span>{{ 'form.error.required' | translate }}</span>
          }
          @if (form.get('name')?.errors?.['minlength']) {
            <span>
              {{
                'form.error.minlength' | translate: form.get('name')?.errors?.['minlength']
              }}
            </span>
          }
          @if (form.get('name')?.errors?.['maxlength']) {
            <span>
              {{
                'form.error.maxlength' | translate: form.get('name')?.errors?.['maxlength']
              }}
            </span>
          }
        </div>
      }
    </div>

    <!-- Description Field -->
    <div class="flex w-full flex-col gap-2">
      <p class="text-sm font-semibold text-zinc-700 dark:text-zinc-300">
        {{ 'common.description' | translate }}
      </p>
      <textarea
        formControlName="description"
        class="border-default bg-elevated focus:ring-accent-focus min-h-[80px] w-full resize-y rounded-lg border px-3 py-2.5 text-sm transition-all focus:border-transparent focus:ring-2 focus:outline-none disabled:opacity-60"
        [class.border-red-500]="
          form.get('description')?.invalid && form.get('description')?.touched
        "
        [class.focus:ring-red-500]="
          form.get('description')?.invalid && form.get('description')?.touched
        ">
      </textarea>

      @if (form.get('description')?.invalid && form.get('description')?.touched) {
        <div class="flex flex-col gap-1 text-xs text-red-500">
          @if (form.get('description')?.errors?.['maxlength']) {
            <span>
              {{
                'form.error.maxlength'
                  | translate: form.get('description')?.errors?.['maxlength']
              }}
            </span>
          }
        </div>
      }
    </div>
  </form>

  <div class="border-weak mt-4 flex items-center justify-end gap-2 border-t pt-3">
    <app-button
      size="lg"
      type="cancel"
      [label]="'common.cancel' | translate"
      (clickEvent)="onCancel()" />
    <app-button
      size="lg"
      type="primary"
      [icon]="submitIcon()"
      [label]="submitLabel()"
      [disabled]="form.invalid || submitting()"
      (clickEvent)="onSubmit()" />
  </div>
</div>
